var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191E1E",
    d: "M12 4.332V.805a.33.33 0 0 0-.567-.234l-1.187 1.187A6.007 6.007 0 0 0 5.44.025C2.645.278.345 2.525.038 5.319a6 6 0 0 0 11.915 1.427.67.67 0 0 0-.666-.747.656.656 0 0 0-.654.573 4.678 4.678 0 0 1-4.7 4.094c-2.475-.033-4.562-2.12-4.602-4.6C1.291 3.466 3.405 1.33 6 1.33a4.68 4.68 0 0 1 3.3 1.367L7.907 4.092a.334.334 0 0 0 .233.573h3.528A.33.33 0 0 0 12 4.332Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/Update.ab83c1bd110ab663fc1dd2ee3158401b.svg";
export { ForwardRef as ReactComponent };